import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineAim } from "react-icons/ai";
import {
  ALL_PROJECTS,
  COMMUNITY,
  FLOOR_PRICE,
  HYPE,
  MARKET_CAP,
  SAVE_LIKES,
  SORT_USER_LIKES,
  SUPPLY,
  UPCOMING_PROJECTS,
  VOLUME_HS,
} from "../../../Redux/actions/actions";
import ProjectInfo from "../ProjectInfo/ProjectInfo";
import s from "../Ranking/Ranking.module.css";
import Navbar from "../../Landing/navbar/navbar";
import { gradientColor } from "../../../helper/helper";
import InfoIcon from "@mui/icons-material/Info";
import AlertDialog from "../../Dialog/Dialog";

import { Waveform } from "@uiball/loaders";
import { Snackbar } from "@mui/material";
import SimpleDialog from "../../Login/dialogLogin/DialogLogin";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";

export default function AllProjects({ colorFondo, setColorFondo }) {
  const dispatch = useDispatch();
  const [sort, setSorted] = useState("hype");
  const [hypeInfo, setHypeInfo] = useState(false);
  const user = useSelector((state) => state.clientReducer.user);
  const likedProjects = useSelector(
    (state) => state.clientReducer.likedProjects
  );
  const [openLogin, setOpenLogin] = useState(false);
  const [likeChanges, setLikedChanges] = useState(false);

  const topProjects = useSelector(
    (state) => state.clientReducer.mintedProjects
  );
  let dmText =
    "Attention,%20soldier!%20I%20hereby%20request%20the%20enlistment%20of%20my%20project!🫡🪖";
  let backgroundColor = gradientColor(colorFondo);

  const hypeOpen = () => {
    setHypeInfo(!hypeInfo);
  };

  const community = () => {
    dispatch(COMMUNITY("minted"));
    setSorted("community");
  };

  const handleMarket = () => {
    dispatch(MARKET_CAP());
    setSorted("marketCap");
  };

  const handleVolume = () => {
    dispatch(VOLUME_HS());
    setSorted("volume");
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setLikedChanges(false);
  };

  const save = () => {
    if (user.ok) {
      console.log({ likedProjects });
      console.log("esta logueado");
      console.log(likedProjects);
      let body = {
        _id: user.id,
        projectsLiked: likedProjects,
      };
      dispatch(SAVE_LIKES(body));
    } else {
      setOpenLogin(true);
    }
    handleClose();
  };

  const handleSupply = () => {
    dispatch(SUPPLY());
    setSorted("supply");
  };

  const handleUserLikes = () => {
    dispatch(SORT_USER_LIKES("user_likes"));
    setSorted("user_likes");
  };

  const handleFloor = () => {
    dispatch(FLOOR_PRICE());
    setSorted("floor");
  };

  const handleHype = () => {
    dispatch(HYPE("minted"));
    setSorted("hype");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(ALL_PROJECTS());
    // dispatch(UPCOMING_PROJECTS());
  }, []);

  const action = (
    <React.Fragment style={{ backgroundColor: "red" }}>
      <Button color="success" size="small" onClick={() => save()}>
        Save
      </Button>
      <Button color="error" size="small" onClick={() => handleClose()}>
        Cancel
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={() => handleClose()}
      >
        <CloseIcon fontSize="small" onClick={() => handleClose()} />
      </IconButton>
    </React.Fragment>
  );

  return (
    <>
      <Navbar colorFondo={colorFondo} />
      <div className={s[colorFondo]}>
        <div className={s.tablaContainer}>
          <div className={s.btnTitle}>
            <div className={s.titleContainer}>
              <h3 className={s.titulo}>VENOM Projects</h3>
              <h4>
                The current list of<span> All NFTs</span> in the{" "}
                <span>Venom</span> ecosystem
                {/* <AiOutlineAim color="#f2c53d" style={{paddingLeft: "0.5em", cursor:"pointer"}}/> */}
              </h4>
            </div>
            <div className={s.buttonContainer}>
              <div className={s.buttonDiv}>
                <a
                  style={backgroundColor}
                  target="_blank"
                  href={
                    "https://twitter.com/messages/compose?recipient_id=1617597356001591325&text=" +
                    dmText
                  }
                  class="twitter-dm-button"
                  data-screen-name="@furni"
                >
                  List your Project
                </a>
              </div>
              <div className={s.buttonDiv}>
                <Link to="/testnet" style={backgroundColor}>
                  Testnet Projects
                </Link>
              </div>
            </div>
          </div>
          {topProjects.length ? (
            <div className={s.grid} style={{ cursor: "auto" }}>
              <div className={s.rows}>
                <div>
                  <span></span>
                </div>
                <div>
                  <span></span>
                </div>
                <div>
                  <span>Project</span>
                </div>
                <div>
                  <span
                    style={{ cursor: "pointer" }}
                    className={sort === "community" && s.underline}
                    onClick={() => community()}
                  >
                    community
                  </span>
                </div>
                <div className={s.hypeDiv}>
                  <span
                    className={sort === "hype" && s.underline}
                    onClick={() => handleHype()}
                  >
                    hype
                  </span>
                  <InfoIcon className={s.infoIcon} onClick={() => hypeOpen()} />
                </div>
                <div>
                  <span
                    className={sort === "user_likes" && s.underline}
                    onClick={() => handleUserLikes()}
                  >
                    Users Likes
                  </span>
                </div>
              </div>
              {topProjects?.map((project, index) => {
                return (
                  <ProjectInfo
                    setColorFondo={setColorFondo}
                    userLikes={project.userLikes}
                    setOpenLogin={setOpenLogin}
                    user={user}
                    likeChanges={likeChanges}
                    setLikedChanges={setLikedChanges}
                    id={project._id}
                    colorFondo={colorFondo}
                    altoUrl={project.altoUrl}
                    url={project.url}
                    key={project._id}
                    name={project.name}
                    twitterFollowers={project.twitterFollowers}
                    img={project.img}
                    i={index}
                    minted={project.minted}
                    volumeToday={project.minted ? project.volumeToday : ""}
                    supply={project.minted ? project.supply : ""}
                    totalVolume={project.minted ? project.totalVolume : ""}
                    floorPrice={project.minted ? project.floorPrice : ""}
                    hype={project.hype}
                  />
                );
              })}
              <AlertDialog hypeInfo={hypeInfo} hypeOpen={hypeOpen} />
            </div>
          ) : (
            <Waveform size={40} lineWeight={3.5} speed={1} color="black" />
          )}
          <Snackbar
            open={likeChanges}
            // autoHideDuration={6000}
            // onClose={()=> handleClose()}
            message="Save Changes"
            action={action}
          />
          <SimpleDialog onClose={() => setOpenLogin(false)} open={openLogin} />
        </div>
      </div>
    </>
  );
}
